export default [
  {
    question: "À quelle fréquence utilisez-vous le masque?",
    answer1: "Toujours",
    answer2: "Presque toujours",
    answer3: "Fréquemment",
    answer4: "Quelquefois",
    answer5: "Presque jamais",
    answer6: "Jamais",
    img: "/images/survey/mascarilla.svg",
    advice: "Vous devriez porter le masque plus fréquemment.",
    inverted: true,
  },
  {
    question: "À quelle fréquence vous lavez-vous les mains?",
    answer1: "Toujours",
    answer2: "Presque toujours",
    answer3: "Fréquemment",
    answer4: "Quelquefois",
    answer5: "Presque jamais",
    answer6: "Jamais",
    img: "/images/survey/lavado-manos.svg",
    advice: "Vous devez vous laver les mains plus fréquemment.",
    inverted: true,
  },
  {
    question:
      "Combien d'heures par semaine restez-vous hors de chez vous dans des espaces ouverts?",
    answer1: "Plus que 50",
    answer2: "40 à 50",
    answer3: "30 à 40",
    answer4: "20 à 30",
    answer5: "10 à 20",
    answer6: "0 à 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Combien d'heures par semaine restez-vous hors de chez vous dans des espaces fermés?",
    answer1: "Plus que 50",
    answer2: "40 à 50",
    answer3: "30 à 40",
    answer4: "20 à 30",
    answer5: "10 à 20",
    answer6: "0 à 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "À quelle fréquence touchez-vous votre visage?",
    answer1: "Toujours",
    answer2: "Presque toujours",
    answer3: "Fréquemment",
    answer4: "Quelquefois",
    answer5: "Presque jamais",
    answer6: "Jamais",
    img: "/images/survey/tocar-cara.svg",
    advice: "Essayez d'être conscient et de ne pas toucher votre visage.",
    inverted: false,
  },
  {
    question: "Combien de personnes vivent dans votre maison, à part vous?",
    answer1: "5 ou plus",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Gardez-vous la distance sociale recommandée avec le reste des gens?",
    answer1: "Toujours",
    answer2: "Presque toujours",
    answer3: "Fréquemment",
    answer4: "Quelquefois",
    answer5: "Presque jamais",
    answer6: "Jamais",
    img: "/images/survey/distanciamiento.svg",
    advice:
      "Essayez de garder la distance recommandée avec des autres personnes.",
    inverted: true,
  },
  {
    question: "Utilisez-vous de l'argent?",
    answer1: "Toujours",
    answer2: "Presque toujours",
    answer3: "Fréquemment",
    answer4: "Quelquefois",
    answer5: "Presque jamais",
    answer6: "Jamais",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Combien de minutes par semaine utilisez-vous l'ascenseur communautaire?",
    answer1: "Jamais",
    answer2: "0 à 2",
    answer3: "2 à 5",
    answer4: "5 à 10",
    answer5: "10 à 20",
    answer6: "Plus que 20",
    img: "/images/survey/ascensor.svg",
    advice:
      "Si possible, utilisez les escaliers, ce qui vous donne également un peu d'exercice.",
    inverted: true,
  },
  {
    question:
      "Combien d'heures par semaine utilisez-vous les transports en commun?",
    answer1: "Plus que 25",
    answer2: "20 à 25",
    answer3: "15 à 20",
    answer4: "10 à 15",
    answer5: "5 à 10",
    answer6: "0 à 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
